<template>
      <div class="heros">
        <div class="container">
            <div class="hero">
                <h4 class="text-capitalize">{{content[0]}}</h4>
                <h1 class="fw-bold">{{content[1]}}</h1>
                <p>{{content[2]}}</p>
                <button>Learn more</button>
            </div>
            <div class="social-media">
                <a href="#">Instagram</a>
                <a href="#">Behance</a>
                <a href="#">Facebook</a>
            </div>
        </div>
      </div>
      <secAbout :about="about"/>
      <secService :services="service" :socials="social"/>
      <secProject/>
      <secJoin :join="join"/>
</template>

<script>
import secAbout from '../homeSection/secAbout.vue'
import secService from '../homeSection/secService.vue'
import secProject from '../homeSection/secProject.vue'
import secJoin from '../homeSection/secJoin.vue'
    export default {
        components:{
            secAbout,
            secService,
            secProject,
            secJoin
        },
        data () {
            return{
                content : ['let do something',
                            'Creative',
                            'We help umkm in advancing their business through a professional website to reach consumers more broadly at affordable prices.'
                        ],
                about : {
                        title : 'We are a creative agency with added value for your business.',
                        isi : 'We are a creative agency located in Batam, Indonesia. we focus on creating websites and graphic designs such as company profile websites, umkm product info websites, mobile apps design, and logo design.',
                        image : require('../assets/img-home/bg-section1.png')
                    } ,
                service: {
                        title : 'We provide the best service for the success of your business.',
                        content : 'Services we offer to you such as website creation, website design, and logo design.',
                    },
                join : {
                    title : 'Have a project for us ?',
                    content : 'If you have a project that needs a developer, please press order below or you want a consultation, you can contact us.',
                },
                social :[
                    {
                        title : 'Web Development',
                        content : 'we focus on creating a company profile website, landing page.',
                        icon : 'https://img.icons8.com/pastel-glyph/30/FFD60A/website--v2.png'
                    },
                    {
                        title : 'Logo Design',
                        content : 'we focus on creating a company profile website, landing page.',
                         icon : 'https://img.icons8.com/external-kiranshastry-lineal-kiranshastry/30/FFD60A/external-graphic-design-graph-design-kiranshastry-lineal-kiranshastry-2.png'
                    },
                    {
                        title : 'UI Design',
                        content : 'we focus on creating a company profile website, landing page.',
                         icon : 'https://img.icons8.com/external-yogi-aprelliyanto-detailed-outline-yogi-aprelliyanto/30/FFD60A/external-ui-design-web-design-and-development-yogi-aprelliyanto-detailed-outline-yogi-aprelliyanto.png'
                    },
                ],

                    
                
            }
        },
        
    }
</script>

<style scoped>
    .heros{
        background: url('../assets/img-home/bg-hero.jpg');
        width: 100%;
        height: 100vh;
        background-position: center;
        background-size: cover;
    }
    .hero{
        color: #ffff;
    }
    .hero h4{
        color: #FFD60A;
        letter-spacing: .25em;
        font-weight: 600;
    }
    .hero p{
        width: 30%;
    }
    .hero button{
        padding: 6px 12px;
        font-size: 1rem;
        border: 3px solid #FFD60A;
        border-radius: 30px;
        background-color: unset;
        color: #ffff;
        transition: ease-out .3s;
    }
    .hero button:hover{
        background-color: #FFD60A;
    }
    .social-media{
        margin-top: 120px;
    }
    .social-media a{
        margin-left: 50px;
        text-decoration: none;
        color: #ffff;
        transition: all .3s ease-out;
    }
    .social-media a:hover{
        color: #FFD60A;
    }
    /* Large Desktop */
    @media(min-width: 1025px){
          .hero{
            padding-top: 250px;
        }
        .hero h4{
            font-size: 1.2rem;
        }
        .hero h1{
            font-size: 6rem;
        }
        .hero p{
            width: 25rem;
        }
        .social-media{
            margin-top: 150px;
            float: right;
        }
    }
    /* Desktop */
    @media(min-width:992px) and (max-width: 1024px){
         .hero{
            padding-top: 220px;
        }
        .hero h4{
            font-size: 1rem;
        }
        .hero h1{
            font-size: 6rem;
        }
        .hero p{
            width: 25rem;
        }
        .social-media{
            margin-top: 150px;
            float: right;
        }
    }
    /* Tablet */
    @media(min-width: 768px) and (max-width: 991px){
        
        .hero{
            padding-top: 200px;
        }
        .hero h4{
            font-size: 1rem;
        }
        .hero h1{
            font-size: 5.5rem;
        }
        .hero p{
            width: 22rem;
        }
        .social-media{
            margin-top: 100px;
            float: right;
        }
    }
    /* Handphone */
    @media(max-width: 767px){
        .hero{
            padding-top: 250px;
        }
        .hero h4{
            font-size: 1rem;
        }
        .hero h1{
            font-size: 4.5rem;
        }
        .hero p{
            width: 100%;
        }
         .social-media{
            display: none;
        }
    }
</style>